import React from "react";
import { useNavigate } from "react-router-dom";
import "./SupportPage.css";

function SupportPage() {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate("/home");
  };

  return (
    <main className="support-page">
      <div className="support-page-container">
        {/* Header */}
        <div className="support-page-header">
          <h1 className="support-page-title">Customer Support</h1>
          <p className="support-page-subtitle">
            We're here to help! Get in touch with our support team for any
            questions or assistance.
          </p>
        </div>

        <div className="support-page-content">
          {/* Quick Support Options */}
          <div className="support-page-options">
            <h2 className="support-page-section-title">
              Quick Support Options
            </h2>
            <div className="support-page-options-grid">
              <div className="support-page-option-card">
                <div className="support-page-option-icon">📧</div>
                <h3>Email Support</h3>
                <p>
                  Send us an email and we'll get back to you within 24 hours.
                </p>
                <a
                  href="mailto:help@reppi.co"
                  className="support-page-option-link"
                >
                  help@reppi.co
                </a>
              </div>

              <div className="support-page-option-card">
                <div className="support-page-option-icon">❓</div>
                <h3>FAQ</h3>
                <p>Find answers to commonly asked questions about Reppi.</p>
                <button
                  className="support-page-option-link"
                  onClick={() =>
                    document
                      .getElementById("faq")
                      .scrollIntoView({ behavior: "smooth" })
                  }
                >
                  View FAQ
                </button>
              </div>

              <div className="support-page-option-card">
                <div className="support-page-option-icon">🏠</div>
                <h3>Back to Home</h3>
                <p>Return to the main page to learn more about Reppi.</p>
                <button
                  className="support-page-option-link"
                  onClick={handleBackToHome}
                >
                  Go to Home
                </button>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="support-page-faq-section" id="faq">
            <h2 className="support-page-section-title">
              Frequently Asked Questions
            </h2>
            <div className="support-page-faq-list">
              <div className="support-page-faq-item">
                <h3>What is Reppi?</h3>
                <p>
                  Reppi is an all-in-one workspace designed for sales
                  representatives to learn, perform, and thrive. It provides
                  training modules, performance tracking, and management tools
                  to help sales teams succeed.
                </p>
              </div>

              <div className="support-page-faq-item">
                <h3>How do I get started with Reppi?</h3>
                <p>
                  To get started, contact us for an invitation or speak with
                  your company administrator if your organization is already
                  using Reppi. You'll receive an invitation email to create your
                  account.
                </p>
              </div>

              <div className="support-page-faq-item">
                <h3>Is there a mobile app available?</h3>
                <p>
                  Currently, Reppi is available as a web application that works
                  on all devices through your browser. There is also an iOS app
                  in the app store.
                </p>
              </div>

              <div className="support-page-faq-item">
                <h3>How can I reset my password?</h3>
                <p>
                  You can reset your password by clicking the "Forgot Password"
                  link on the login page and following the instructions sent to
                  your email.
                </p>
              </div>

              <div className="support-page-faq-item">
                <h3>Who can access training materials?</h3>
                <p>
                  All registered sales representatives can access training
                  materials assigned to them. Managers and admins can also
                  create and assign training content.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default SupportPage;
